module.exports = __webpack_public_path__ + "img/orientation-horizontal-on.8e193761.svg";